import { Icon, IconColorType, IconNameType } from '@octano/global-ui';
import { useMemo } from 'react';
import { SingleValueProps } from 'react-select';

export interface OptionTypeIcon {
  value: string;
  label: string;
}

export interface IconOptionProps<T extends OptionTypeIcon>
  extends SingleValueProps<T> {
  statusColorMap: Record<string, IconColorType>;
  statusIconMap: Record<string, IconNameType>;
}

export default function IconOption<T extends OptionTypeIcon>(
  props: IconOptionProps<T>,
) {
  const { data, statusColorMap, statusIconMap } = props;

  const iconData = useMemo(() => {
    const status = data!.value;
    return {
      color: statusColorMap[status],
      icon: statusIconMap[status],
    };
  }, [data, statusColorMap, statusIconMap]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Icon
        className="icon-select"
        color={iconData.color}
        name={iconData.icon}
        size="15px"
      />
      <span>{data?.label}</span>
    </div>
  );
}
